import { render, staticRenderFns } from "./BannerWidget.vue?vue&type=template&id=0862caa1&scoped=true"
import script from "./BannerWidget.vue?vue&type=script&lang=js"
export * from "./BannerWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0862caa1",
  null
  
)

export default component.exports